var WorkEditModal = (function (base) {
  __extends(WorkEditModal, base);


  function WorkEditModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
    };

    function _getRoadStartKm() {
        var roadStartKm = parseFloat($('#RoadId').find(':selected').data('start-km'));
        return roadStartKm || 0;
    }

  WorkEditModal.prototype.activate = function (workId, isCopy) {

    const self = this;
    const isNew = !workId;
    const url = isNew ? 'api/works/add' : 'api/works/{0}/edit'.format(workId);

    this.loadContent(isCopy ? 'api/works/{0}/copy'.format(workId) : url)
      .then($modal => {

          $('#transportLocationReport').removeAttr('js');
          $('#transportLocationReport').find('[js="single"]').removeAttr('name');
          $('#transportLocationReport').find('[js="single"]').removeAttr('id');

        workId = isCopy ? '' : workId;
        var $form = $('form', $modal);
        FormHelper.init($form, isNew || isCopy ? 'PUT' : 'POST', 'api/works');

        $('#DateDue', $modal).closest('.date').datepicker({
          language: 'ru',
          format: 'yyyy-mm-dd',
          todayHighlight: true,
          toggleActive: true,
          autoclose: true
        });

        datetimepickerRangeInit({ $inputFrom: $('#StartTime', $modal), $inputTo: $('#StopTime', $modal), format: 'YYYY-MM-DD HH:mm' });
        datetimepickerRangeInit({ $inputFrom: $('#From', $modal), $inputTo: $('#To', $modal), withSeconds: true });

        coordinates.reloadRoadCoordinates().then(function () {
            coordinates.updateCoordinates({ isPoint: false, roadStartKm: _getRoadStartKm() });
          });

        if (Number($('#SectionServiceId').val()) && Number($('#SectionServiceId').val()) > 0) {
            $('#RoadId').attr('disabled', 'disabled');
            $('#RoadId').trigger('chosen:updated');
            $('#RoadName').attr('disabled', 'disabled');
            $('#RoadName').trigger('chosen:updated');
            $('#StartKm').attr('readonly', 'true');
            $('#StopKm').attr('readonly', 'true');
            $('[js=edit-coordinates]').attr('disabled', 'disabled');
        }

        if (Number($('#RoadId').val()) && Number($('#RoadId').val()) > 0) {
            $('#SectionServiceId option').css('display', 'none');
            $('[data-roadid="{0}"], [value="0"]'.format(Number($('#RoadId').val())), '#SectionServiceId').css('display', 'block');
        }

        $modal

          //Кнопка 'Сохранить'
            .on('click', '[js=save]', function () {
                $('#RangeError').removeClass('input-validation-error');
                $('#RangeError').removeAttr('aria-describedby');
            $modal.busy();
            $form.send()
              .then(id => { self.close({ ok: true, data: id }); })
              .catch(() => {
                  $modal.busy(false);
                  if ($('#RangeError').hasClass('input-validation-error')) {
                      $('#StartKm').val('');
                      $('#StopKm').val('');
                  }
              });
              
          })

          .on('change', '#VehicleIds', () => {
            $('[data-valmsg-for=VehicleIds]').text(""); // Стираем сообщение валидации
          })

            //Выбор кода автодороги
            .on('change', '#RoadId', (e) => {
                onRoadChanged($(e.currentTarget), $('#RoadName'));
            })

            //Выбор наименования автодороги
            .on('change', '#RoadName', (e) => {
                onRoadChanged($(e.currentTarget), $('#RoadId'));
            })

            //Выбор участка обслуживания
            .on('change', '#SectionServiceId', function () {
                $('[data-valmsg-for=RoadId]').text(""); // Стираем сообщение валидации
                $('[data-valmsg-for=StartKm]').text(""); // Стираем сообщение валидации
                $('[data-valmsg-for=StopKm]').text(""); // Стираем сообщение валидации
                var $selected = $('option:selected', '#SectionServiceId');

                if (!$('#SectionServiceId').val() || $('#SectionServiceId').val() == 0) {
                    $('#RoadId').removeAttr('disabled');
                    $('#RoadId').trigger('chosen:updated');
                    $('#RoadName').removeAttr('disabled');
                    $('#RoadName').trigger('chosen:updated');

                    $('#StartKm').removeClass('input--disabled').removeAttr('readonly');
                    $('#StopKm').removeClass('input--disabled').removeAttr('readonly');
                    $('[js=edit-coordinates]').removeAttr('disabled');
                    $('#SectionServiceId option').css('display', 'none');
                    $('[data-roadid="{0}"], [value="0"]'.format($('#RoadId').val()), '#SectionServiceId').css('display', 'block');
                } else {
                    $('#RoadId').val($selected.data('roadid'));
                    $('#RoadId').attr('disabled', 'disabled');
                    $('#RoadId').trigger('chosen:updated');
                    $('#RoadName').val($selected.data('roadid'));
                    $('#RoadName').attr('disabled', 'disabled');
                    $('#RoadName').trigger('chosen:updated');

                    $('#StartKm').val($selected.data('startkm'));
                    $('#StopKm').val($selected.data('stopkm'));
                    $('#StartKm').attr('readonly', 'true');
                    $('#StopKm').attr('readonly', 'true');
                    $('[js=edit-coordinates]').attr('disabled', 'disabled');

                    coordinates.reloadRoadCoordinates($selected.data('roadid'))
                        .then(() => {
                            coordinates.updateCoordinates({ isPoint: false, roadStartKm: _getRoadStartKm() });
                        });
                }
            })

          ////Выбор участка обслуживания
          //.on('change', '#SectionServiceId', function () {
          //      updateSectionServiceData();
          //  })

            //Изменение километра работы на дороге
            .on('change', '#StartKm', () => {
                $('[data-valmsg-for=StartKm]').text(""); // Стираем сообщение валидации
                coordinates.updateCoordinates({ isPoint: false, roadStartKm: _getRoadStartKm() });
            })

            //Изменение километра работы на дороге
            .on('change', '#StopKm', () => {
                $('[data-valmsg-for=StopKm]').text(""); // Стираем сообщение валидации
                coordinates.updateCoordinates({ isPoint: false, roadStartKm: _getRoadStartKm() });
            })

            //Кнопка 'Задать координату на карте'
            .on('click', '[js=edit-coordinates]', () => {

                const roadId = parseInt($('#RoadId option:selected', $modal).val());
                const workName = $('#Name', $modal).val();
                const startKm = parseFloat($('#StartKm', $modal).val());
                const stopKm = parseFloat($('#StopKm', $modal).val());
                const roadStartKm = _getRoadStartKm();

                ModalConductor.activate(WorkMapModal, workId, roadId, workName, roadStartKm, startKm, stopKm)
                    .on('closed',
                        modalResult => {
                            if (modalResult.ok) {
                                $('#StartKm', $modal).val(modalResult.startKm);
                                $('#StopKm', $modal).val(modalResult.stopKm);
                            }
                        });
            })

          // Смена кода вида работ
          .on('change', '#WorkTypeCode', function () {
            var $control = $("#WorkTypeCode option:selected", $modal);
            $('#WtwId', $modal).val($control.data('wtwid'));
            $('#WorkTypeId', $modal).val($control.data('id'));
            $('#WorkTypeName', $modal).val($control.data('name'));
            $('#WorkTypeName', $modal).trigger("chosen:updated");
            $('#WorkTypeUnit', $modal).val($control.data('unit'));

            var qfirst = typeof $control.data('qfirst') === "string" ? $control.data('qfirst').replace(',', '.') : $control.data('qfirst');
            var qsecond = typeof $control.data('qsecond') === "string" ? $control.data('qsecond').replace(',', '.') : $control.data('qsecond');
            if ($('#RegionalCoefficientId', $modal).val() == 1) {
              $('#WorkTypeQuotation', $modal).val(qfirst);
              $('#WorkTypeQuotation2', $modal).val(qsecond);
            } else {
              $('#WorkTypeQuotation', $modal).val(qsecond);
              $('#WorkTypeQuotation2', $modal).val(qfirst);
            }
          })

          // Смена вида работ
          .on('change', '#WorkTypeName', function () {
            var $control = $("#WorkTypeName option:selected", $modal);
            $('#WtwId', $modal).val($control.data('wtwid'));
            $('#WorkTypeId', $modal).val($control.data('id'));
            $('#WorkTypeCode', $modal).val($control.data('code'));
            $('#WorkTypeCode', $modal).trigger("chosen:updated");
            $('#WorkTypeUnit', $modal).val($control.data('unit'));

            var qfirst = typeof $control.data('qfirst') === "string" ? $control.data('qfirst').replace(',', '.') : $control.data('qfirst');
            var qsecond = typeof $control.data('qsecond') === "string" ? $control.data('qsecond').replace(',', '.') : $control.data('qsecond');
            if ($('#RegionalCoefficientId', $modal).val() == 1) {
              $('#WorkTypeQuotation', $modal).val(qfirst);
              $('#WorkTypeQuotation2', $modal).val(qsecond);
            } else {
              $('#WorkTypeQuotation', $modal).val(qsecond);
              $('#WorkTypeQuotation2', $modal).val(qfirst);
            }
          })

          // Смена кода материала
          .on('change', '#MaterialCode', function () {
            var $control = $('#MaterialCode option:selected', $modal);
            $('#MaterialId', $modal).val($control.data('id'));
            $('#MaterialName', $modal).val($control.data('name'));
            $('#MaterialName', $modal).trigger("chosen:updated");
            $('#MaterialUnit', $modal).val($control.data('unit'));
          })

          // Смена материала
          .on('change', '#MaterialName', function () {
            var $control = $('#MaterialName option:selected', $modal);
            $('#MaterialId', $modal).val($control.data('id'));
            $('#MaterialCode', $modal).val($control.data('code'));
            $('#MaterialCode', $modal).trigger("chosen:updated");
            $('#MaterialUnit', $modal).val($control.data('unit'));
          })

          // Изменение районного коэф-та
          .on('change', '#RegionalCoefficientId', function () {
            if ($(this).val() == 1) {
              var q1 = $('#WorkTypeQuotation', $modal).val();
              var q2 = $('#WorkTypeQuotation2', $modal).val();
              $('#WorkTypeQuotation', $modal).val(q2);
              $('#WorkTypeQuotation2', $modal).val(q1);

              $.each($('table.table.work-type-table tbody tr', $modal),
                  function (idx, obj) {
                    var td1 = $(obj).children('td.quotation1', $modal).text();
                    var td2 = $(obj).children('td.quotation2', $modal).text();

                    $(obj).children('td.quotation1', $modal).html(td2);
                    $(obj).children('td.quotation2', $modal).html(td1);
                  });
            } else {
              var q1 = $('#WorkTypeQuotation2', $modal).val();
              var q2 = $('#WorkTypeQuotation', $modal).val();
              $('#WorkTypeQuotation2', $modal).val(q2);
              $('#WorkTypeQuotation', $modal).val(q1);

              $.each($('table.table.work-type-table tbody tr', $modal),
                  function (idx, obj) {
                    var td1 = $(obj).children('td.quotation2', $modal).text();
                    var td2 = $(obj).children('td.quotation1', $modal).text();

                    $(obj).children('td.quotation2', $modal).html(td2);
                    $(obj).children('td.quotation1', $modal).html(td1);
                  });
            }
          })

          // Добавление нового вида работ
          .on('click', '#addWorkType', function () {
            if ($('#addWorkType', $modal).attr('disabled') === undefined) {
              $('#addWorkType', $modal).attr('disabled', 'disabled');
              $('#WorkTypeCode', $modal).parent().parent().children('span').text('');

                var workTypeId = parseInt($('#WtwId', $modal).val());

              const url = isNew || isCopy ? 'api/works/add/workTypes' : 'api/works/{0}/edit/workTypes'.format(workId);
              self.apiClient.put(url, {
                WtwId: $('#WtwId', $modal).val(),
                VolumeOfWorks: $('#VolumeOfWorks', $modal).val(),
                WorkTypeId: $('#WorkTypeId', $modal).val(),
                WorkTypeCode: $('#WorkTypeCode', $modal).val(),
                WorkTypeName: $('#WorkTypeName', $modal).val(),
                WorkTypeUnit: $('#WorkTypeUnit', $modal).val(),
                WorkTypeQuotation: $('#WorkTypeQuotation', $modal).val(),
                WorkTypeQuotation2: $('#WorkTypeQuotation2', $modal).val()
              })
              .then(function (result) {
                $('#addWorkType', $modal).removeAttr('disabled');
                  if (result.workTypes) {
                      var needWorkName = $('#Name', $modal).val().replace(/\s/g, '').length < 1;
                  var table = '';
                    result.workTypes.forEach(function(obj, index) {
                        if (needWorkName && obj.WorkTypeId === workTypeId) {
                            $('#Name', $modal).val(obj.Name);
                        }
                    table += '<tr> <td>' + obj.Code +
                      '</td> <td>' + obj.Name +
                      '</td> <td>' + obj.Unit +
                      '</td> <td class="quotation1">' + obj.Quotation1 +
                      '</td> <td class="hidden quotation2">' + obj.Quotation2 +
                      '</td> <td> <div class="input-group">' + obj.VolumeOfWorks +
                      '<span class="input-group-btn"> <a class="pull-right btn btn-sm btn-default no-borders del-worktype" data-wtwid="' + obj.Id + '" data-id="' + obj.WorkTypeId +
                      '" data-volume="' + obj.VolumeOfWorks +
                      '"><i class="fa fa-minus"></i></a> </span> </div> </td> </tr>';
                  });

                  if (result.materials) {
                    result.materials.forEach(function (obj, index) {
                      table += '<tr> <td>' + obj.Code +
                        '</td> <td>' + obj.Name +
                        '</td> <td>' + obj.Unit +
                        '</td> <td>' + obj.Cost +
                        '</td> <td class="hidden">' + obj.Cost +
                        '</td> <td> <div class="input-group">' + obj.VolumeOfMaterials +
                        '<span class="input-group-btn"> <a class="pull-right btn btn-sm btn-default no-borders del-material" data-id="' + obj.MaterialId +
                        '" data-volume="' + obj.VolumeOfMaterials +
                        '" data-cost="' + obj.Cost +
                        '"><i class="fa fa-minus"></i></a> </span> </div> </td> </tr>';
                    });
                  }

                      var selectOld = $('#WorkTypeCode', $modal).parent().html();
                      if (selectOld) {
                          var selectNew =
                              '<select data-placeholder="Введите код вида работы" class="chosen-select" tabindex="2" id="WorkTypeCode" name="WorkTypeCode">' +
                                  $('#WorkTypeCode', $modal).html() +
                                  '</select>';

                          var selectOldName = $('#WorkTypeName', $modal).parent().html();
                          var selectNewName =
                              '<select data-placeholder="Введите наименование работы" class="chosen-select" tabindex="2" id="WorkTypeName" name="WorkTypeName">' +
                                  $('#WorkTypeName', $modal).html() +
                                  '</select>';
                          table += '<tr class="work-type-table-tr">' +
                              $('table.work-type-table tbody tr.work-type-table-tr', $modal).html()
                              .replace(selectOld, selectNew).replace(selectOldName, selectNewName) +
                              '</tr>';
                      }
                      var selectOldMaterialName = $('#MaterialName', $modal).parent().html();
                      if (selectOldMaterialName) {
                          var selectNewMaterialName =
                              '<select data-placeholder="Введите наименование материала" class="chosen-select" tabindex="2" id="MaterialName" name="MaterialName">' +
                                  $('#MaterialName', $modal).html() +
                                  '</select>';
                          var selectOldMaterial = $('#MaterialCode', $modal).parent().html();
                          var selectNewMaterial =
                              '<select data-placeholder="Введите код материала" class="chosen-select" tabindex="2" id="MaterialCode" name="MaterialCode">' +
                                  $('#MaterialCode', $modal).html() +
                                  '</select>';
                          table += '<tr class="material-table-tr">' +
                              $('table.work-type-table tbody tr.material-table-tr', $modal).html()
                              .replace(selectOldMaterial, selectNewMaterial)
                              .replace(selectOldMaterialName, selectNewMaterialName) +
                              '</tr>';
                      }
                      $("table.work-type-table tbody", $modal).html(table);
                } else {
                  if (result.error) {
                    $.each($('.field-validation-valid.text-danger'),
                      function (idx, obj) {
                        if ($(obj).data('valmsgFor') === result.error.field) {
                          $(obj).text(result.error.text);
                        }
                        $('#' + result.error.field)
                          .on('change',
                            function () {
                              $(obj).text('');
                            });
                      });
                  }
                }
                ChosenSelect.Init();
              })
              .catch(function () {
                $('#addWorkType', $modal).removeAttr('disabled');
              });
            }
          })

          // Удаление вида работ
          .on('click', '.del-worktype', function () {
            var $control = $(this);
            const url = isNew || isCopy ? 'api/works/add/workTypes' : 'api/works/{0}/edit/workTypes'.format(workId);

            self.apiClient.delete(url, {
              WtwId: $control.data('wtwid'),
              WorkTypeId: $control.data('id'),
              VolumeOfWorks: $control.data('volume')
            })
            .then(result => {
              if (result) {
                $control.closest('tr').remove();
              }
            });
          })

          // Добавление нового материала
          .on('click', '#addMaterial', function () {
            var $control = $(this);
            if ($control.attr('disabled') === undefined) {
              $control.attr('disabled', 'disabled');
              $('#MaterialCode', $modal).parent().parent().children('span').text('');

              const url = isNew || isCopy ? 'api/works/add/materials' : 'api/works/{0}/edit/materials'.format(workId);
              self.apiClient.put(url, {
                VolumeOfMaterials: $('#VolumeOfMaterials', $modal).val(),
                MaterialId: $('#MaterialId', $modal).val(),
                MaterialCode: $('#MaterialCode', $modal).val(),
                MaterialName: $('#MaterialName', $modal).val(),
                MaterialUnit: $('#MaterialUnit', $modal).val(),
                MaterialQuotation: $('#MaterialQuotation', $modal).val(),
              })
              .then(function (result) {
                $control.removeAttr('disabled');
                if (result.materials) {
                  var table = '';

                  if (result.workTypes) {
                    result.workTypes.forEach(function (obj, index) {
                      table += '<tr> <td>' + obj.Code +
                        '</td> <td>' + obj.Name +
                        '</td> <td>' + obj.Unit +
                        '</td> <td class="quotation1">' + obj.Quotation1 +
                        '</td> <td class="hidden quotation2">' + obj.Quotation2 +
                        '</td> <td> <div class="input-group">' + obj.VolumeOfWorks +
                        '<span class="input-group-btn"> <a class="pull-right btn btn-sm btn-default no-borders del-worktype" data-wtwid="' + obj.Id + '" data-id="' + obj.WorkTypeId +
                        '" data-volume="' + obj.VolumeOfWorks +
                        '"><i class="fa fa-minus"></i></a> </span> </div> </td> </tr>';
                    });
                  }

                  result.materials.forEach(function (obj, index) {
                    table += '<tr> <td>' + obj.Code +
                      '</td> <td>' + obj.Name +
                      '</td> <td>' + obj.Unit +
                      '</td> <td>' + obj.Cost +
                      '</td> <td class="hidden">' + obj.Cost +
                      '</td> <td> <div class="input-group">' + obj.VolumeOfMaterials +
                      '<span class="input-group-btn"> <a class="pull-right btn btn-sm btn-default no-borders del-material" data-id="' + obj.MaterialId +
                      '" data-volume="' + obj.VolumeOfMaterials +
                      '" data-cost="' + obj.Cost +
                      '"><i class="fa fa-minus"></i></a> </span> </div> </td> </tr>';
                  });

                  if ($('tr.work-type-table-tr', $modal).html()) {
                    var selectOldWork = $('#WorkTypeCode', $modal).parent().html();
                    var selectNewWork = '<select data-placeholder="Введите код вида работы" class="chosen-select" tabindex="2" id="WorkTypeCode" name="WorkTypeCode">' + $('#WorkTypeCode', $modal).html() + '</select>';
                    var selectOldWorkName = $('#WorkTypeName', $modal).parent().html();
                    var selectNewWorkName = '<select data-placeholder="Введите наименование работы" class="chosen-select" tabindex="2" id="WorkTypeName" name="WorkTypeName">' + $('#WorkTypeName', $modal).html() + '</select>';

                      table += '<tr class="work-type-table-tr">' + $('table.work-type-table tbody tr.work-type-table-tr', $modal).html().replace(selectOldWork, selectNewWork).replace(selectOldWorkName, selectNewWorkName) + '</tr>';
                  }

                  if ($('tr.material-table-tr', $modal).html()) {
                    var selectOldMaterialName = $('#MaterialName', $modal).parent().html();
                    var selectNewMaterialName = '<select data-placeholder="Введите наименование материала" class="chosen-select" tabindex="2" id="MaterialName" name="MaterialName">' + $('#MaterialName', $modal).html() + '</select>';
                    var selectOldMaterial = $('#MaterialCode', $modal).parent().html();
                    var selectNewMaterial =
                      '<select data-placeholder="Введите код материала" class="chosen-select" tabindex="2" id="MaterialCode" name="MaterialCode">' + $('#MaterialCode', $modal).html() + '</select>';
                    table += '<tr class="material-table-tr">' +
                      $('table.work-type-table tbody tr.material-table-tr', $modal).html().replace(selectOldMaterial, selectNewMaterial).replace(selectOldMaterialName, selectNewMaterialName) + '</tr>';
                  }

                  $("table.work-type-table tbody", $modal).html(table);
                } else {
                  if (result.error) {
                    $.each($('.field-validation-valid.text-danger'),
                      function (idx, obj) {
                        if ($(obj).data('valmsgFor') === result.error.field) {
                          $(obj).text(result.error.text);
                        }
                        $('#' + result.error.field)
                          .on('change',
                            function () {
                              $(obj).text('');
                            });
                      });
                  }
                }
                ChosenSelect.Init();
              })
              .catch(function () {
                $('#addMaterial', $modal).removeAttr('disabled');
              });
            }
          })

          // Удаление материала
          .on('click', '.del-material', function () {
            var $control = $(this);
            const url = isNew || isCopy ? 'api/works/add/materials' : 'api/works/{0}/edit/materials'.format(workId);

            self.apiClient.delete(url, {
              MaterialId: $control.data('id'),
              VolumeOfMaterials: $control.data('volume'),
              MaterialQuotation: $control.data('cost')
            })
            .then(result => {
              if (result) {
                $control.closest('tr').remove();
              }
            });
          })
                      
            // 
          .on('click', '[js=fill-work]', (e) => {
              var vehicles = VehicleOnObjectsReport.GetSelectedVehicles();
                fillWork(vehicles);
            });
      });
    };

    function updateSectionServiceData() {
        var $selected = $('#SectionServiceId option').filter(':selected');

        if (!$('#SectionServiceId').val() || $('#SectionServiceId').val() == 0) {
            $('#StartKm').val('');
            $('#StopKm').val('');
            $('#Road').val('');
        } else {
            $('#StartKm').val($selected.data('startkm'));
            $('#StopKm').val($selected.data('stopkm'));
            $('#Road').val($selected.data('roadCode'));
        }
    }

    function findSectionService(roadId, startKm, stopKm) {
        var ssOnRoad =  $('#SectionServiceId option[data-roadid=' + roadId + ']');
        if (ssOnRoad.length) {
            var intersected = ssOnRoad.filter(function(s) {
                var start = $(this).data('startkm');
                var stop = $(this).data('stopkm');
                return start < stopKm && stop > startKm;
            });
            if (intersected.length)
                return $(intersected[0]).val();
            return $(ssOnRoad[0]).val();
        }
        return null;
    }

  function fillWork(vehicles) {
      if (vehicles.length > 0) {
          var dateFormat = "DD-MM-YYYY HH:mm:ss";
          var contractorId = vehicles[0].contractorId;
          var vehicleId = vehicles[0].vehicleId;
          var roadId = vehicles[0].roadId;
          var startTime = moment(vehicles[0].startTime, dateFormat).toDate();
          var stopTime = moment(vehicles[0].stopTime, dateFormat).toDate();
          var startKm = vehicles[0].startKm;
          var stopKm = vehicles[0].stopKm;
          for (var i = 1; i < vehicles.length; i++) {
              var startVehicle = moment(vehicles[i].startTime, dateFormat).toDate();
              var stopVehicle = moment(vehicles[i].stopTime, dateFormat).toDate();
              if (startVehicle < startTime)
                  startTime = startVehicle;
              if (stopVehicle > stopTime)
                  stopTime = stopVehicle;
              if (startKm > vehicles[i].startKm)
                  startKm = vehicles[i].startKm;
              if (stopKm < vehicles[i].stopKm)
                  stopKm = vehicles[i].stopKm;
          }
          // Округление до минут в большую сторону
          stopTime.setSeconds(stopTime.getSeconds() + 59);
          stopTime.setSeconds(0);

          var $contractor = $('#ContractorId');
          if (canFillField($contractor)) {
              $contractor.val(contractorId);
          }
          var $road = $('#RoadId');
          if (canFillField($road)) {
              $('#RoadId').val(roadId);
              $('#RoadName').val(roadId);
              $('#RoadId').trigger('chosen:updated');
              $('#RoadName').trigger('chosen:updated');
          }
          var $startTime = $('#StartTime');
          var $stopTime = $('#StopTime');
          if (canFillField($startTime) && canFillField($stopTime)) {
              $startTime.closest('.date').data('DateTimePicker').clear();
              $stopTime.closest('.date').data('DateTimePicker').clear();
              $startTime.closest('.date').data('DateTimePicker').date(startTime);
              $stopTime.closest('.date').data('DateTimePicker').date(stopTime);
          }
          var $selectedVehicles = $('#VehicleId');
          if (canFillField($selectedVehicles)) {
              $selectedVehicles.val(vehicleId);
              $selectedVehicles.trigger('chosen:updated');
          }
          var $startKm = $('#StartKm');
          if (canFillField($startKm)) {
              $startKm.val(startKm);
          }
          var $stopKm = $('#StopKm');
          if (canFillField($stopKm)) {
              $stopKm.val(stopKm);
          }
          //var $sectionService = $('#SectionServiceId');
          //if (canFillField($sectionService)) {
          //    var sectionService = findSectionService(roadId, startKm, stopKm);
          //    {
          //        if (sectionService) {
          //            $('#SectionServiceId').val(sectionService);
          //            updateSectionServiceData();
          //        }
          //    }
          //}
      }
  }

  function canFillField($input) {
      return $input.length !== 0 && !$input.is(':disabled') && !$input.is('[readonly]');  
  }

  function _toTimeParsing(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var parseHours = hours > 9 ? hours : '0' + hours;
    var parseMinutes = minutes > 9 ? minutes : '0' + minutes;
    return parseHours + ':' + parseMinutes;
  }

    function onRoadChanged($changed, $toChange) {
        var changedId = $changed.val();
        $toChange.val(changedId);
        $toChange.trigger('chosen:updated');

          $('[data-valmsg-for=RoadId]').text(""); // Стираем сообщение валидации
          $('[data-valmsg-for=StartKm]').text(""); // Стираем сообщение валидации
          $('[data-valmsg-for=StopKm]').text(""); // Стираем сообщение валидации
          
          coordinates.reloadRoadCoordinates()
            .then(() => {
              coordinates.updateCoordinates({ isPoint: false, roadStartKm: _getRoadStartKm() });
            });
          $('#SectionServiceId option').css('display', 'none');
          $('[data-roadid="{0}"], [value="0"]'.format($changed.val()), '#SectionServiceId').css('display', 'block');
          if ($changed.val() == 0) {
            $('#SectionServiceId option').css('display', 'block');
          }

    }


  return WorkEditModal;
}(BaseModal));
